import Separator from "@components/CustomTypography/Separator/Separator"
import SocialResponsibilityContactFormSection from "@components/Pages/SocialResponsibility/SocialResponsibilityForm/SocialResponsibilityContactFormSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import ContactJson from "@jsons/contactUs.json"
import ContactUsHeaderSection from "@pages/ContactUs/ContactUsHeader/ContactUsHeaderSection"
import ContactUsLocationSection from "@pages/ContactUs/ContactUsLocation/ContactUsLocationSection"
import ContactUsSection from "@pages/ContactUs/ContactUsMainSections/ContactUsSection"
import React from "react"

type Props = {}

const ContactUs = (props: Props): JSX.Element => {
	const pageData = getTranslatedPageData(ContactJson, true, true)
	const ContactUsSections = getValueOrThrow(pageData.AdvancedSideAsset)
	const ContactUsCards = getValueOrThrow(pageData.contactUsCardData)
	return (
		<>
			<HeadMeta meta={pageData.metaData} customPath={"/contact-us"} />

			<ContactUsHeaderSection
				data={getValueOrThrow(ContactUsSections?.[0].mainContent)[0]}
			/>

			<ContactUsSection
				backgroundColor={"white"}
				cards={ContactUsCards[0]}
				data={ContactUsSections[1]}
			/>

			<ContactUsSection cards={ContactUsCards[1]} />
			<Separator />
			<ContactUsSection
				cards={ContactUsCards[2]}
				data={ContactUsSections[2]}
			/>
			<Separator />
			<ContactUsSection
				cards={ContactUsCards[3]}
				data={ContactUsSections[3]}
			/>

			<ContactUsLocationSection data={ContactUsSections[4]} />
			<Separator size={32} />
			<Separator />
			<SocialResponsibilityContactFormSection
				data={ContactUsSections[5]}
			/>
		</>
	)
}

export default ContactUs
